import { render, staticRenderFns } from "./AnswersList.vue?vue&type=template&id=0ad8cb8c&scoped=true"
import script from "./AnswersList.vue?vue&type=script&lang=js"
export * from "./AnswersList.vue?vue&type=script&lang=js"
import style0 from "./AnswersList.vue?vue&type=style&index=0&id=0ad8cb8c&prod&lang=scss&scoped=true"
import style1 from "./AnswersList.vue?vue&type=style&index=1&id=0ad8cb8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad8cb8c",
  null
  
)

export default component.exports